import { render } from "./RegisterStep2.vue?vue&type=template&id=6c8231a0&scoped=true&lang=pug"
import script from "./RegisterStep2.vue?vue&type=script&lang=js"
export * from "./RegisterStep2.vue?vue&type=script&lang=js"

import "./RegisterStep2.vue?vue&type=style&index=0&id=6c8231a0&scoped=true&lang=scss"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c8231a0"]])

export default __exports__